import React, { useState, useEffect, useRef } from 'react';
import Container from '../../UI/Container/Container';
import Button from '../../UI/Button/Button';
import { getAppOptions } from '../../../utils/lib';
import './Form.css';



const Form = (props) => {

    const [fromDestination, setFromDestination] = useState({
        address: "",
        lat: "",
        lng: ""
    });
    const [toDestination, setToDestination] = useState({
        address: "",
        lat: "",
        lng: ""
    });

    const fromRef = useRef('');
    const toRef = useRef('');

    const  [inputOneState, setInputOneState]    = useState(false);
    const  [inputTwoState, setInputTwoState]    = useState(false);
    const  [disabledButton, setDisabledButton]  = useState(false);

    //formatted_address,lat,lng all go under basic data from places api

 
    
    const getSelectedFromLocation = () => {
      
        let autoCompleteFrom = new window.google.maps.places.Autocomplete(fromRef.current,{
            fields: ["formatted_address", "geometry"]
        });
        new window.google.maps.event.addListener(autoCompleteFrom, "place_changed", function () {
            let from = autoCompleteFrom.getPlace();
            setFromDestination({
                address: from.formatted_address,
                lat: from.geometry.location.lat(),
                lng: from.geometry.location.lng()
            });
            setInputOneState(true);
            
        });
    }
    
    const getSelectedToLocation = () => {
      
        let autoCompleteTo = new window.google.maps.places.Autocomplete(toRef.current,{
            fields: ["formatted_address", "geometry"]
        });
        new window.google.maps.event.addListener(autoCompleteTo, "place_changed", function() {
            let to = autoCompleteTo.getPlace();
            setToDestination({
                address: to.formatted_address,
                lat: to.geometry.location.lat(),
                lng: to.geometry.location.lng(),
            });
            setInputTwoState(true);
        });
    }

    //when testing hard code the lat and lng at a specific location to not use up to many api calls
    useEffect(() => {
        // setFromDestination({
        //     address: "Västerås, Sverige",
        //     lat: 59.60990049999999,
        //     lng: 16.5448091
        // });
        // setToDestination({
        //     address: "Goole, Storbritannien",
        //     lat: 53.7044721,
        //     lng: -0.874562,
        // });
        // setInputOneState(true);
        // setInputTwoState(true);
        getSelectedFromLocation();
        getSelectedToLocation();
    }, []);

    //disable/enable button
    useEffect(() => {
        if(inputOneState === false || inputTwoState === false){
            setDisabledButton(true);
        }else{
            setDisabledButton(false);
        }
    }, [inputOneState, inputTwoState])

    const fromChangeHandler = () => {
        if(fromRef.current.value === ''){
            setInputOneState(false);
        }
    }
    const toChangeHandler = () => {
        if(toRef.current.value === ''){
            setInputTwoState(false);
        }
    }

    // get driving distance from start to finish
    const getDrivingDistance = () => {
        let totalDistance = [];
        let service = new window.google.maps.DistanceMatrixService();
        
        let fromOrigin = new window.google.maps.LatLng(Number(fromDestination.lat), Number(fromDestination.lng));
        let toOrigin = new window.google.maps.LatLng(Number(toDestination.lat), Number(toDestination.lng));

        service.getDistanceMatrix({
            origins: [fromOrigin],
            destinations: [toOrigin],
            travelMode: 'DRIVING'
        }, matrixCallback);

        function matrixCallback(response, status) {
            
            if(status === "OK"){
                var destination = response.destinationAddresses[0];
                var currentOrigin = response.originAddresses[0];
                console.log(response);
                if(response.rows[0].elements[0].status === "ZERO_RESULTS"){
                    props.zeroResults({
                        zeroResultsId: 2, 
                        zeroResultsMessage: 'Direct transport by road is not possible.', 
                        zeroResultsState:true
                    });
                }else{
                    let distance = response.rows[0].elements[0].distance.value;
                    totalDistance.push(currentOrigin, destination, distance);
                    props.setTotalDistance(totalDistance);
                }
                
            }
        }   
    }

    const getClosestPorts = async () => {
        
        let shortestDistanceResult = [];
        //options data from admin
        const optionsData = await getAppOptions();
        
        //origins
        let fromOrigin = new window.google.maps.LatLng(Number(fromDestination.lat), (fromDestination.lng));
        let toOrigin = new window.google.maps.LatLng(Number(toDestination.lat), (toDestination.lng));
    
        //google requires array for destinations argument.
        const destinationsArr = [];
        const portKeysArr = [];
        const portNamesArr = [];
        for(let i = 0; i < optionsData.port_locations.length; i++){
            destinationsArr.push(optionsData.port_locations[i].port_name);
            //this is needed to find the correct port combination
            portKeysArr.push(optionsData.port_locations[i].port_key);
            portNamesArr.push(optionsData.port_locations[i].port_name);
        }

        //console.log(portKeysArr);
        let service = new window.google.maps.DistanceMatrixService();
        
        service.getDistanceMatrix({
            origins: [fromOrigin, toOrigin],
            destinations: destinationsArr,
            travelMode: 'DRIVING',
        }, matrixCallback);
    
        function matrixCallback(response, status){
            if(status === 'OK'){
                console.log(response);
                var origins = response.originAddresses;
                var destinations = response.destinationAddresses;
                
                for(var i = 0; i < origins.length; i++){

                   
                    var results = response.rows[i].elements;
                    var currentOrigin = origins[i]; 
                    var index = 0;
                    if(response.rows[i].elements[0].status !== "ZERO_RESULTS"){
                        var shortestDistance = results[0].distance.value;
                        var shortestDistanceDestination = destinations[0];
                    }

                    for(var j = 0; j < results.length; j++){

                        //get desination with shortest distance   
                        if(response.rows[i].elements[j].status !== "ZERO_RESULTS"){
                            var tempDistance = results[j].distance.value;
                            if(tempDistance < shortestDistance){
                                shortestDistance = tempDistance;
                                shortestDistanceDestination = destinations[j];
                                index = j;
                            }
                        }
                    }
                    shortestDistanceResult.push({
                        currentOrigin, 
                        shortestDistanceDestination, 
                        shortestDistance, 
                        portKey: portKeysArr[index], 
                        originalPortLocation: portNamesArr[index] 
                    });
                }
                
                if(shortestDistanceResult.length < 2){
                    props.zeroResults({
                        zeroResultsId: 3, 
                        zeroResultsMessage: 'No roads could be found between either origin - destination pairs', 
                        zeroResultsState:true
                    });
                }else{
                    props.setDataHandler(shortestDistanceResult, toDestination, fromDestination);
                }
            }
            if(status === 'ZERO_RESULTS'){
                props.zeroResults({
                    zeroResultsId: 3, 
                    zeroResultsMessage: 'No roads could be found between either origin - destination pairs', 
                    zeroResultsState:true
                });
            }
            
            props.setOnCalculate(true);
        }   
    }


    const onSubmitTsgFormHandler = (e) => {
        e.preventDefault();
        getClosestPorts();
        getDrivingDistance();
    }
   

    return(
        <Container>
            <div className="tsg-form-container">
                <h2 className="tsg-htitle">How much CO2 would you save shipping by sea?</h2>

                <form className="tsg-form" type="submit" onSubmit={onSubmitTsgFormHandler}>
                    <div className="tsg-form-groups">
                        <div className="tsg-form-group">
                            <label className="tsg-label">From:</label>
                            <input className="tsg-input" placeholder="Enter a place" id="tsg-from-destination" type="text" onChange={fromChangeHandler} name="from-destination" ref={fromRef}/>
                        </div>
                        <div className="tsg-form-group">
                            <label className="tsg-label">To:</label>
                            <input className="tsg-input" placeholder="Enter a place" id="tsg-to-destination" type="text" onChange={toChangeHandler} name="to-destination" ref={toRef}/>
                        </div>
                    </div>
                    <Button disabledButton={disabledButton}>Check how much you save</Button>
                </form>
            </div>  
        
        </Container>
    );
}

export default Form;